// import React, { FC, useEffect, useState } from "react";
// import Loader, { Spinner } from "../../../utils/Spinners";

// type PreAuthScreenProps = {
//   urlLink: string;
//   setClaimId: CallableFunction;
// };

// const PreAuthScreen: FC<PreAuthScreenProps> = (props) => {
//   const [isLoading, setIsLoading] = useState(true);
//   const [isUrlValid, setIsUrlValid] = useState<boolean | null>(null);

//   useEffect(() => {
//     const handleMessage = (event: MessageEvent) => {
//       if (event.data.type === 'ID_RECEIVED') {
//         props?.setClaimId(event.data.payload); 
//       }
//       if (event.data.type === 'IFRAME_READY') {
//         // Get localStorage data you want to send
//         const localStorageData = {
//           accessModules: localStorage.getItem('accessModules'),
//           // Add any other localStorage items you need
//         };
//         

//         // Send localStorage data to iframe
//         const iframe = document.querySelector('iframe');
//         iframe?.contentWindow?.postMessage({
//           type: 'LOCAL_STORAGE_DATA',
//           payload: localStorageData
//         }, '*'); // Replace with actual iframe domain
//       }
//     };

    

//     window.addEventListener('message', handleMessage);

//     return () => {
//       window.removeEventListener('message', handleMessage);
//     };
//   }, []);

//   const handleIframeLoad = () => {
//     setIsLoading(false);
//   };

//   // useEffect(() => {
//   //   const checkUrl = async () => {
//   //     try {
//   //       const response = await fetch(props?.urlLink, { method: "HEAD" });
//   //       if (response.status === 200 || response.status === 304) {
//   //         setIsUrlValid(true);
//   //       } else {
//   //         setIsUrlValid(false);
//   //       }
//   //     } catch (error) {
//   //       setIsUrlValid(false);
//   //     }
//   //     // setIsLoading(false);
//   //   };

//   //   if (props?.urlLink) {
//   //     checkUrl();
//   //   }
//   // }, [props.urlLink]);

//   // if (isLoading) {
//   //   return <Loader />;
//   // }

//   // if (!isUrlValid) {
//   //   return <p>Please, Refresh the Page.</p>;
//   // }


//   return (
//     <div style={{ height: "100vh" }}>
//       {isLoading && <Loader />}
//       <div style={{ position: "relative", width: "100%", height: "100%" }}>
//         {props?.urlLink ? (
//           <iframe
//             src={props?.urlLink}
//             width="100%"
//             height="100%"
//             title="External Page"
//             style={{ border: "none", position: "absolute", zIndex: "2" }}
//             onLoad={handleIframeLoad}
//           ></iframe>
//         ) : (
//           <p>
//             <Loader />
//           </p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PreAuthScreen;
import React, { FC, useEffect, useState } from "react";
import Loader from "../../../utils/Spinners";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";

type PreAuthScreenProps = {
  urlLink: string;
  setClaimId: CallableFunction;
  isScreen: string;
  setRegId: CallableFunction;
  setMoveToNext: CallableFunction;
  nextStage: any;
  role: string | null;
  setRenderToTop:CallableFunction
};

const PreAuthScreen: FC<PreAuthScreenProps> = (props) => {
  const { stepperData, currentStep } = useSelector(
    (state: RootState) => state.preAuth
  );
  const currentStageDetails = stepperData?.currentVisitStage;
  const currentActiveStage = stepperData?.visitStages[currentStep];
  
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'ID_RECEIVED') {
        props?.setClaimId(event.data.payload);
      }
      
      if (event.data.type === 'NEXT_STAGE') {
        props?.setMoveToNext(event.data.payload);
      }
      
      if(event.data.type === 'REG_ID_RECEIVED'){
        props?.setRegId(event.data.payload);
      }
      if(event.data.type === 'RENDDER_TO_TOP'){
        props?.setRenderToTop(event.data.payload);
     
      }
      
      // Handle ready message from iframe
      if (event.data.type === 'IFRAME_READY') {
        const accessModules = localStorage.getItem('accessModules');
        const iframe = document.querySelector('iframe');
        iframe?.contentWindow?.postMessage({
          type: 'ACCESS_MODULES_DATA',
          payload: {
            parentUrl: window.location.origin,
            isScreen: props?.isScreen,
            accessModules: accessModules || '{}',
            nextStage: props?.nextStage,
            role: props?.role,
            currentStageDetails: currentStageDetails,
            currentActiveStage: currentActiveStage,
          }
        }, '*'); 
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [props.setClaimId, props?.isScreen, props]);

  const handleIframeLoad = () => {
    setIsLoading(false);
    // Send initial data on load
    const accessModules = localStorage.getItem('accessModules');
    const iframe = document.querySelector('iframe');
    iframe?.contentWindow?.postMessage({
      type: 'ACCESS_MODULES_DATA',
      payload: accessModules || '{}'
    }, '*'); // Use * during development
  };


  return (
    // //"50vh" : "100vh"
    <div style={{ height: props?.isScreen?.toLowerCase() === "portal registration" ? "74.6vh" : "149.25vh" }}>   
      {isLoading && <Loader />}
      <div style={{ position: "relative", width: "100%", height: "100%" }}>
        {props?.urlLink ? (
          <iframe
            src={props?.urlLink}
            width="100%"
            height="100%"
            title="External Page"
            style={{ border: "none", position: "absolute", zIndex: "2" }}
            onLoad={handleIframeLoad}
            key={props?.isScreen}
          ></iframe>
        ) : (
          <p>
            <Loader />
          </p>
        )}
      </div>
    </div>
  );
};

export default PreAuthScreen;